module.exports = __webpack_public_path__ + "static/media/package_detail.68fe3a42.jpg";